import React from 'react';

const DEFAULT_DECORATOR_CONFIG = {
  visibleLimitInFields: 2,
  visibleLimitInRows: 1,
};

const DecoratorConfigContext = React.createContext(DEFAULT_DECORATOR_CONFIG);

export { DEFAULT_DECORATOR_CONFIG };
export const DecoratorConfigProvider = DecoratorConfigContext.Provider;
export default DecoratorConfigContext;
